import { render, staticRenderFns } from "./SettingsScreen.vue?vue&type=template&id=18f6e0fc&"
import script from "./SettingsScreen.vue?vue&type=script&lang=ts&"
export * from "./SettingsScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./SettingsScreen.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports